import axiosInstance from "./instance";

const instance = axiosInstance();
const headers = new Headers({ 'Content-Type': 'application/octet-stream' });

export const postDocuments = async (userId, type, file) => {
    try {
        const response = await instance.post(`/${userId}/user-profile/${type}/upload`, file,{
            headers: headers
        });
        console.log("upload responce-->", response);
        return response;
    } catch (error) {
        console.log("upload error-->", error);
        return error;
    }
}

export const uploadApplicationDocuments = async (userId,applicationID, type, file) => {
    try {
        const response = await instance.post(`/${userId}/apply-universities/${type}/upload/${applicationID}`, file,{
            headers: headers
        });
        console.log("upload responce-->", response);
        return response;
    } catch (error) {
        console.log("upload error-->", error);
        return error;
    }
}

export const postTestScores = async (data) => {
    try {
        const response = await instance.post(`users/test-scores`, data);
        console.log("test responce-->", response);
        return response;
    } catch (error) {
        console.log("test error-->", error);
    }
}

export const updateTestScores = async (data) => {
    try {
        const response = await instance.put(`/users/test-scores/${data.id}`,data);
        return response;
    } catch (error) {
        return error;
    }

}
export const uploadUserProfile = async (userId, type, file) => {
    try {        
        const formData = new FormData();
        formData.append('file', file);
        const response = await instance.post(`/${userId}/${type}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        console.log("upload response-->", response);
        return response;
    } catch (error) {
        console.error("upload error-->", error);
        throw error;
    }
}


export const getUserDocuments = async (userId, key,options) => {
    try {
        const response = await instance.get(`/${userId}/user-profile/download/${key}`,options);
        console.log("get with key responce-->", response);
        return response;
    } catch (error) {
        console.log("get with key error-->", error);
        return error;
    }
}

export const getProfileDetails = async (userId) => {
    try {
        const response = await instance.get(`/users/profile-details/user/${userId}`);
        console.log("upload responce-->", response);
        return response;
    } catch (error) {
        console.log("upload error-->", error);
        return error;
    }
}

export const getEducationDetails = async (userId) => {
    try {
        const response = await instance.get(`/users/educational-details/user/${userId}`);
        console.log("get responce-->", response);
        return response;
    } catch (error) {
        console.log("upload error-->", error);
        return error;
    }
}

export const getTestScores = async (userId) => {
    try {
        const response = await instance.get(`/users/test-scores/user/${userId}`);
        console.log("get testScores responce-->", response);
        return response;
    } catch (error) {
        console.log("upload error-->", error);
        return error;
    }
}

export const getProfileDocuments = async (userId) => {
    try {
        const response = await instance.get(`/user-profile/user/${userId}`);
        console.log("get Documents responce-->", response);
        return response;
    } catch (error) {
        console.log("upload error-->", error);
        return error;
    }
}